import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  icon: {
    cursor: (p) => (p.disabled ? 'default' : 'pointer'),
    pointerEvents: (p) => (p.disabled ? 'none' : 'all'),
  },
}));

export default useStyles;
